import styled from 'styled-components';
import { Button } from '../../components';
const DropdownWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;
const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  margin-bottom: 16px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
`;

const ProductImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  padding: 24px;
  background: #fff;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ProductContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
`;

const ProductTitle = styled.h3`
  margin: 0 0 10px;
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
`;

const ProductDescription = styled.p`
  margin: 0 0 20px;
  color: #666666;
  font-size: 14px;
  line-height: 1.6;
`;

const ProductQuantity = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #eeeeee;
`;

const QuantityLabel = styled.span`
  color: #666666;
  font-size: 13px;
  line-height: 1.4;
`;

const QuantityValue = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 32px;
  padding: 0 10px;
  border-radius: 16px;
  background: #eaf6ed;
  color: #3f9d52;
  font-size: 14px;
  font-weight: 600;
`;
const CheckoutSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e6e6e6;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

const CheckoutDisclaimer = styled.div`
  flex: 1;

  p {
    margin: 0;
    color: #666666;
    font-size: 12px;
    line-height: 1.6;
  }
`;

const CheckoutButton = styled(Button)`
  flex-shrink: 0;
  min-width: 180px;
  height: 50px;
  border-radius: 6px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;
export default {
  DropdownWrap,
  QuantityLabel,
  QuantityValue,
  ProductQuantity,
  ProductDescription,
  ProductCard,
  ProductTitle,
  ProductImageWrapper,
  ProductContent,
  ProductImage,
  ProductsGrid,
  CheckoutSection,
  CheckoutButton,
  CheckoutDisclaimer,
};
